import { Filesystem, Directory, Encoding } from '@capacitor/filesystem';

// plugin's methods
const methods = [
	'checkPermissions',
	'requestPermissions',
	'readFile',
	'readFileInChunks',
	'writeFile',
	'appendFile',
	'deleteFile',
	'mkdir',
	'rmdir',
	'readdir',
	'getUri',
	'stat',
	'rename',
	'copy',
];

export function useNativeFilesystem () {
	// methods
	const api = methods.reduce((api, name) => {
		api[name] = Filesystem[name];
		return api;
	}, {});

	return {
		...api,
		Directory,
		Encoding,
	};
}
